// Coaching.Config_NoteCategory.NoteCategory
export enum NoteCategory {
    GENERAL = 1,
    DID_WELL,
    DO_DIFFERENTLY,
    COMMENT,
    I_WILL,
    I_WILL_KNOW,
    GENERAL_NOTE,
}
